import { Grid, Typography } from '@mui/material';
import { Form } from 'react-final-form';
import { useLocation, useNavigate } from 'react-router';
import { Spacer, Column, ButtonFooter } from '../../components';
import MembersFileUpload from './MembersFileUpload';
import { useNavigatedFromBulkAdd } from '../../hooks/useNavigatedFromBulkAdd';

const AddMembersBulk: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const inOffboarding = !location.pathname.includes('onboarding');
  const { setNavigatedFromBulkAdd } = useNavigatedFromBulkAdd();

  const onSubmit = async () => {
    if (inOffboarding) {
      setNavigatedFromBulkAdd(true);
      navigate(-1);
    } else {
      navigate('/members');
    }
  };

  const leftButtonOnSubmit = () => {
    if (inOffboarding) {
      setNavigatedFromBulkAdd(true);
    }
    navigate(-1);
  };

  return (
    <Form onSubmit={onSubmit}>
      {({ handleSubmit }) => (
        <Column
          style={{
            padding: '15px 100px 150px 100px',
            minHeight: '100vh',
            display: 'flex',
          }}>
          <Spacer height='sm' />

          <Grid style={{ flexGrow: 1 }}>
            <Typography color='secondary.main' variant='p50Light'>
              Bulk add
            </Typography>
            <Spacer height='sm' />
            <MembersFileUpload mode='add/edit' />
          </Grid>

          <ButtonFooter
            primaryButton={{
              label: 'Done',
              onClick: handleSubmit,
            }}
            secondaryButton={{
              label: 'Cancel',
              onClick: leftButtonOnSubmit,
              showCondition: true,
            }}
          />
        </Column>
      )}
    </Form>
  );
};

export default AddMembersBulk;
